import { render, staticRenderFns } from "./RootList.vue?vue&type=template&id=6f235fb0&scoped=true"
import script from "./RootList.vue?vue&type=script&lang=js"
export * from "./RootList.vue?vue&type=script&lang=js"
import style0 from "./RootList.vue?vue&type=style&index=0&id=6f235fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f235fb0",
  null
  
)

export default component.exports